import React from "react";
import ReactDOMServer from "react-dom/server";
import { observer } from "mobx-react";
import Propulator from "higher-order/Propulator";
import classNames from "classnames";
import PropTypes from "prop-types";
import filter from "lodash/filter";
import join from "lodash/join";
import trim from "lodash/trim";
import map from "lodash/map";

@observer
class ContentItem extends React.Component {
    static propTypes = {
        tag: PropTypes.string.isRequired,
        className: PropTypes.string,
        contentKey: PropTypes.string.isRequired,
        sharedKey: PropTypes.string,
        stringFormatArgs: PropTypes.object
    };

    static defaultProps = {
        tag: "div"
    }

    get id() {
        return join(filter(map({ sharedKey: this.props.sharedKey, contentKey: this.props.contentKey }, v => trim(v))), "-");
    }

    render() {
        // Destructure props so we can pull out the things we need to process and leave additional attributes intended for the
        // returned element
        const { sharedKey, tag, className, contentKey, stringFormatArgs, extractContent, ...otherProps } = this.props;

        // We don't want to stick the dispatcher into the element we are creating
        delete otherProps.dispatcher;

        const outputContent = extractContent(contentKey, sharedKey, stringFormatArgs);
        
        const cssClasses = classNames("content-item", className);

        // Put any passthrough attributes into the input object for React.createElement
        const props = {
            className: cssClasses,
            dangerouslySetInnerHTML: { __html: outputContent },
            ...otherProps
        };

        return React.createElement(tag, props);
    }
}

export class ContentItemUtilities {
    static stringifyComponent = (component) => {
        return ReactDOMServer.renderToString(component);
    };
}

export default Propulator(ContentItem, {
    contentStore: ["extractContent"]
});
